(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dpr-quick-cart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dpr-quick-add')) {
  customElements.define('dpr-quick-add', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.querySelector('form').addEventListener('submit', (event) => {
        event.preventDefault();
        const button = this.querySelector('button[type=submit]');
        if (button.getAttribute('aria-busy') === 'true') return;
        const data = new FormData(event.currentTarget);
        const status = this.querySelector('[role=status]');
        clearTimeout(this.timer);
        status.textContent = '';
        button.setAttribute('aria-busy', 'true');
        const add = async () => {
          try {
            const drawer = document.querySelector('cart-drawer');
            if (drawer) {
              data.set('sections', drawer.getSectionsToRender().map(section => section.id).join(','));
              data.set('sections_url', window.location.pathname);
            }
            const response = await fetch(window.routes.cart_add_url, {
              method: 'POST', headers: {'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest'}, body: data
            });
            const result = await response.json();
            if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
            status.textContent = this.dataset.added;
            if (drawer) {
              drawer.classList.remove('is-empty');
              try { drawer.renderContents(result, false); } catch (error) { console.error(error); }
            }
            this.timer = setTimeout(() => { status.textContent = ''; }, 4000);
          } catch (error) {
            status.textContent = error.message || this.dataset.error;
          } finally {
            button.removeAttribute('aria-busy');
          }
        };
        window.dprQuickAddQueue = (window.dprQuickAddQueue || Promise.resolve()).then(add, add);
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dpr-social-proof-locale"] && !Shopify.designMode) return;
  try {
    (() => {
  const config = document.querySelector('[data-dpr-social-proof]');
  if (!config) return;
  let attempts = 0;
  const connect = () => {
    const shadow = document.getElementById('pop-convert-app')?.shadowRoot;
    if (!shadow) {
      if (++attempts < 60) setTimeout(connect, 1000);
      return;
    }
    const translate = () => {
      shadow.querySelectorAll('.social-pop').forEach(pop => {
        const first = pop.querySelector('p.first');
        const second = pop.querySelector('p.second');
        if (!first || !second) return;
        const count = first.textContent.trim().match(/^(\d+)\s+(?:personas|people)$/);
        const source = second.textContent.trim();
        if (!count) return;
        const cart = source.match(/^Actualmente tienen (.+) en su carrito de compras$/);
        const visited = ['Están viendo esta página ahora mismo', 'Han visitado la tienda en la última hora', config.dataset.visited].includes(source);
        if (!cart && !visited) return;
        const description = cart ? config.dataset.cart.replace('[product]', cart[1]) : config.dataset.visited;
        const title = count[1] + ' ' + config.dataset.people;
        if (first.textContent !== title) first.textContent = title;
        if (second.textContent !== description) second.textContent = description;
      });
    };
    translate();
    new MutationObserver(translate).observe(shadow, {childList: true, subtree: true, characterData: true});
  };
  connect();
})();
  } catch(e) { console.error(e); }
})();

})();
